<template>
    <div>
        <b-modal
            :visible="value"
            :id="modal_id"
            size="lg"
            @cancel="cancel"
            @close="cancel"
            @hidden="hidden"
            @shown="focusSearch"
        >
            <template #modal-title>
                Add Printable PDF
            </template>
            <div class="d-flex w-100 justify-content-end">
                <div class="btn btn-success mr-3" @click="show_upload_printable_modal = true">Add Printable</div>
            </div>
            <printable-search
                ref="printable-search"
                :publication="publication"
                :article="article"
                :article_related_media="article_related_media"
                :type="type"
                @link="linkItem"
            />

            <template #modal-footer>
                <b-button
                    variant="light"
                    @click="cancel"
                >
                    Cancel
                </b-button>
            </template>
        </b-modal>
        <upload-printable-modal
            v-model="show_upload_printable_modal"
            :value="null"
            @hideUploadPrintable="show_upload_printable_modal = false"
            @link="linkItem"
        />
    </div>
</template>

<style lang="scss" scoped>

</style>

<script>
import {mapState} from 'vuex'

import PrintableSearch from '@/components/modals/article/worksheets/Search'
import UploadPrintableModal from '@/components/modals/media/UploadPrintableModal'

export default {
    data: () => ({
        show_upload_printable_modal: false,
    }),
    props: [
        'value',
        'publication',
        'article',
        'article_related_media',
        'type'
    ],
    components: {
        PrintableSearch,
        UploadPrintableModal
    },
    computed: {
        ...mapState({}),
        modal_id() {
            let modal_id = 'add-related-media-modal'
            return modal_id
        }
    },
    methods: {
        linkItem(item) {
            this.$set(item, 'linking', true)
            this.$emit('link', item)
        },
        focusSearch() {
            if (
                this.$refs['printable-search'] &&
                this.$refs['printable-search'].$refs['search-term']
            ) {
                this.$refs['printable-search'].$refs['search-term'].focus()
            }
        },
        cancel(event) {
            event.preventDefault()
            this.hide()
        },
        hide() {
            this.$emit('hide')
        },
        hidden() {
            this.$emit('hide')
        },
    }
}
</script>
